module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/cariene-powell-b5766cf697d85a868cc30a81af6ea8b7.jpg";